module.exports = __webpack_public_path__ + "img/HDR_W660F.6a55dc8b.png";